webpackJsonp([46],{

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-page',{attrs:{"name":"page-process","title":_vm.$route.meta.title}}),_vm._v(" "),_c('div',{staticClass:"px-5"},[_c('app-table',{staticClass:"mt-5 is-not-selectable",attrs:{"name":"table-process","columns":_vm.columns,"rows":_vm.rows,"current-page":_vm.currentPage,"last-page":_vm.lastPage},on:{"on-page":_vm.changePage,"on-search-event":_vm.onSearchInput},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v(_vm._s(props.row.code))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v(_vm._s(props.row.name))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v(_vm._s(props.row.scope))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v(_vm._s(props.row.module))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 5)),expression:"showRow(columns, 5)"}]},[_vm._v(_vm._s(props.row.order))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 6)),expression:"showRow(columns, 6)"}]},[_vm._v(_vm._s(props.row.description))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 7)),expression:"showRow(columns, 7)"}]},[_vm._v(_vm._s(props.row.urlImage))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 8)),expression:"showRow(columns, 8)"}]},[_c('app-tooltip-button',{attrs:{"color":"green","icon":"edit","text":"Editar"},on:{"click-icon":function($event){_vm.editProcess(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"red","icon":"delete","text":"Eliminar"},on:{"click-icon":function($event){_vm.openModalConfirmation(props.row)}}})],1)]}}])}),_vm._v(" "),_c('app-confirmation-modal',{attrs:{"loading":_vm.loading,"show-modal":_vm.modalConfirmation.value},on:{"cancel":_vm.cancelModalConfirmation,"confirm":function($event){_vm.confirm()}}})],1),_vm._v(" "),_c('quick-actions',{attrs:{"actions":_vm.actions},on:{"open-modal":_vm.openModal}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_process_vue__ = __webpack_require__(877);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_221a5fa5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_process_vue__ = __webpack_require__(1128);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_process_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_221a5fa5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_process_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function actionToDo(item) {
	var action = item.link ? item.link : {
		width: item.width ? item.width : 0,
		title: item.text,
		code: item.code,
		active: item.active,
		open: true
	};
	var eventEmit = item.link ? 'to-link' : 'open-modal';
	this.$emit(eventEmit, action);
}

function setBorder(item) {
	var color = item.color === undefined ? '#9b9b9b' : item.color;
	return 'border-bottom: 4px solid ' + color;
}

function setMaxWidth(item) {
	var maxWidth = item.maxWidth ? item.maxWidth + 'px' : 'min-content';
	return 'max-width: ' + maxWidth;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'quick-actions',
	methods: {
		actionToDo: actionToDo,
		setBorder: setBorder,
		setMaxWidth: setMaxWidth
	},
	props: {
		actions: Array
	}
});

/***/ }),

/***/ 567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-confirmation-modal',
	props: {
		cancelText: {
			type: String,
			default: 'Cancelar'
		},
		confirmationText: {
			type: String,
			default: 'Eliminar'
		},
		loading: {
			default: false,
			type: Boolean
		},
		showModal: {
			type: Boolean,
			default: false
		},
		text: {
			type: String,
			default: 'Está seguro que desea eliminar este registro?'
		},
		width: {
			type: Number,
			default: 500
		}
	}
});

/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quick_actions_vue__ = __webpack_require__(566);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33fee913_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_actions_vue__ = __webpack_require__(574);
function injectStyle (ssrContext) {
  __webpack_require__(572)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33fee913"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quick_actions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33fee913_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_actions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(573);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("3369894e", content, true);

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.actions[data-v-33fee913]{background:#fff;bottom:0;left:0;margin:0 auto;position:fixed;right:0;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.actions .actions-bar[data-v-33fee913]{border:1px solid #f1f3f7;border-radius:5px 5px 0 0;padding:0}.actions .actions-bar .action-content[data-v-33fee913]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;height:50px}.actions .actions-bar .action-content .action[data-v-33fee913],.actions .actions-bar .action-content[data-v-33fee913]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.actions .actions-bar .action-content .action[data-v-33fee913]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;height:40px;margin:0 10px;opacity:.3;padding:0;text-align:center;-webkit-transition-timing-function:cubic-bezier(.075,.82,.165,1);transition-timing-function:cubic-bezier(.075,.82,.165,1);-webkit-transition-duration:.5s;transition-duration:.5s;width:140px}.actions .actions-bar .action-content .action .action-txt[data-v-33fee913]{font-family:Opens_regular;font-size:10px;margin:0 0 0 5px;text-align:left}.actions .actions-bar .action-content .action[data-v-33fee913]:hover{margin-top:-20px;-webkit-transform:scale(1.1) translateY(-2px);transform:scale(1.1) translateY(-2px)}.actions .actions-bar .action-content .active[data-v-33fee913]{opacity:1}", "", {"version":3,"sources":["/opt/buildhome/repo/src/components/shared/quick-actions.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,sBAAyB,AACzB,uCAAwC,AACxC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,wCAAyC,AACzC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,0BAA6B,AAC7B,8CAA+C,AAC/C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,2CAA4C,AAC5C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,+CAAgD,AAChD,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,4CAA6C,AAC7C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,0BACE,gBAAkB,AAClB,SAAY,AACZ,OAAU,AACV,cAAiB,AACjB,eAAgB,AAChB,QAAW,AACX,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CACpB,AACD,uCACI,yBAA0B,AAC1B,0BAA2B,AAC3B,SAAa,CAChB,AACD,uDACM,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAS9B,WAAa,CAClB,AACD,sHAVM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CA0BrC,AAvBD,+DACQ,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAS5B,eAAgB,AAChB,YAAa,AACb,cAAe,AACf,WAAa,AACb,UAAa,AACb,kBAAmB,AACnB,iEAAwE,AAChE,yDAAgE,AACxE,gCAAmC,AAC3B,wBAA2B,AACnC,WAAa,CACpB,AACD,2EACU,0BAA6B,AAC7B,eAAgB,AAChB,iBAAwB,AACxB,eAAiB,CAC1B,AACD,qEACQ,iBAAkB,AAClB,8CAA+C,AACvC,qCAAuC,CACtD,AACD,+DACQ,SAAW,CAClB","file":"quick-actions.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_bold';\n  src: url(\"/static/fonts/Lato-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_light';\n  src: url(\"/static/fonts/Lato-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_regular';\n  src: url(\"/static/fonts/OpenSans-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_bold';\n  src: url(\"/static/fonts/OpenSans-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_semibold';\n  src: url(\"/static/fonts/OpenSans-SemiBold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_light';\n  src: url(\"/static/fonts/OpenSans-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n.actions[data-v-33fee913] {\n  background: white;\n  bottom: 0px;\n  left: 0px;\n  margin: 0px auto;\n  position: fixed;\n  right: 0px;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.actions .actions-bar[data-v-33fee913] {\n    border: 1px solid #f1f3f7;\n    border-radius: 5px 5px 0 0;\n    padding: 0px;\n}\n.actions .actions-bar .action-content[data-v-33fee913] {\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      height: 50px;\n}\n.actions .actions-bar .action-content .action[data-v-33fee913] {\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        cursor: pointer;\n        height: 40px;\n        margin: 0 10px;\n        opacity: 0.3;\n        padding: 0px;\n        text-align: center;\n        -webkit-transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\n                transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\n        -webkit-transition-duration: 500ms;\n                transition-duration: 500ms;\n        width: 140px;\n}\n.actions .actions-bar .action-content .action .action-txt[data-v-33fee913] {\n          font-family: \"Opens_regular\";\n          font-size: 10px;\n          margin: 0px 0px 0px 5px;\n          text-align: left;\n}\n.actions .actions-bar .action-content .action[data-v-33fee913]:hover {\n        margin-top: -20px;\n        -webkit-transform: scale(1.1) translateY(-2px);\n                transform: scale(1.1) translateY(-2px);\n}\n.actions .actions-bar .action-content .active[data-v-33fee913] {\n        opacity: 1;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions"},[_c('div',{staticClass:"actions-bar"},[_c('div',{staticClass:"action-content"},_vm._l((_vm.actions),function(action,index){return _c('div',{key:index,staticClass:"action",class:{ active: action.active },style:(_vm.setBorder(action)),on:{"click":function($event){_vm.actionToDo(action)}}},[(action.img)?_c('img',{staticClass:"action-logo",attrs:{"src":action.img,"width":"20px","alt":action.text}}):_c('v-icon',{staticClass:"mb-2"},[_vm._v(_vm._s(action.icon))]),_vm._v(" "),_c('p',{staticClass:"action-txt",style:(_vm.setMaxWidth(action))},[_vm._v(_vm._s(action.text))])],1)}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_confirmation_modal_vue__ = __webpack_require__(567);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da054f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_confirmation_modal_vue__ = __webpack_require__(582);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_confirmation_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da054f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_confirmation_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"value":_vm.showModal,"width":_vm.width}},[_c('v-card',[_c('v-card-text',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.text)+"\n\t\t\t")]),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"btn-action caption",attrs:{"color":"primary","disabled":_vm.loading},on:{"click":function($event){_vm.$emit('cancel')}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.cancelText)+"\n\t\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption",attrs:{"color":"error","disabled":_vm.loading},on:{"click":function($event){_vm.$emit('confirm')}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.confirmationText)+"\n\t\t\t\t")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_app_confirmation_modal__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_app_tooltip_button__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_quick_actions__ = __webpack_require__(571);



var loadProcess = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						params = {
							page: this.params.page,
							perPage: this.params.perPage,
							search: this.params.search,
							projectCode: this.$route.params.codeProject
						};
						_context.prev = 1;
						_context.next = 4;
						return this.$http.get('process', { params: params });

					case 4:
						response = _context.sent;

						this.rows = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);
						_context.next = 12;
						break;

					case 9:
						_context.prev = 9;
						_context.t0 = _context['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 9]]);
	}));

	return function loadProcess() {
		return _ref.apply(this, arguments);
	};
}();

var confirm = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var _this = this;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						this.loading = true;
						this.$http.delete('process/' + this.modalConfirmation.selectedRow.id).then(function () {
							_this.showNotification('Proceso eliminado.');
						}).catch(function (error) {
							if (error.status === 405) {
								if (error.data.message === 'PROCESS_NOT_FOUND') {
									_this.showError('Proceso no existe.');
								}
								if (error.data.message === 'PROCESS_HAS_ASSOCIATED_DATA') {
									_this.showError('Este proceso no esta asociado.');
								}
							}
						}).finally(function () {
							_this.loading = false;
							_this.modalConfirmation.value = false;
							_this.loadProcess();
						});

					case 2:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function confirm() {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function created() {
	this.loadProcess();
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadProcess();
}

function onSearchInput(value) {
	this.params.search = value ? value.trim() : null;
	this.loadProcess();
}

function openModal() {
	this.goTo('create-process');
}

function editProcess(_ref2) {
	var id = _ref2.id;

	this.goTo('edit-process', { params: { id: id } });
}

function data() {
	return {
		actions: [{
			id: 1,
			code: 'CP',
			text: 'Crear Proceso',
			img: 'https://goo.su/sZkMw',
			active: true
		}],
		columns: [{ id: 1, name: 'Código', value: 'code', checked: true, visible: true }, { id: 2, name: 'Nombre', value: 'name', checked: true, visible: true }, { id: 3, name: 'Alcance', value: 'scope', checked: true, visible: true }, { id: 4, name: 'Modulo', value: 'module', checked: true, visible: true }, { id: 5, name: 'Orden', value: 'order', checked: true, visible: true }, { id: 6, name: 'Descripción', value: 'description', checked: true, visible: true }, { id: 7, name: 'Imagen', value: 'image', checked: true, visible: true }, { id: 8, name: 'Acciones', checked: true, visible: true }],
		currentPage: 1,
		idProcess: '',
		loading: false,
		lastPage: 0,
		params: {
			search: null,
			page: 1,
			perPage: 10
		},
		rows: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-process',
	data: data,
	created: created,
	components: {
		appConfirmationModal: __WEBPACK_IMPORTED_MODULE_2__components_shared_app_confirmation_modal__["a" /* default */],
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_3__components_shared_app_tooltip_button__["a" /* default */],
		quickActions: __WEBPACK_IMPORTED_MODULE_4__components_shared_quick_actions__["a" /* default */]
	},
	watch: {
		$route: function $route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-process') {
					this.loadProcess();
				}
			}
		}
	},
	methods: {
		confirm: confirm,
		changePage: changePage,
		editProcess: editProcess,
		loadProcess: loadProcess,
		openModal: openModal,
		onSearchInput: onSearchInput
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/46.2424e45b168acad103c3.js